import React, { Component,PropTypes } from 'react';
import { Link,hashHistory } from "react-router";
import {ellaUrl} from '../../path.config'
import {getUserId,resultTip,successShow,errorShow,language,errToSuc} from "UTIL/common"
import roleService from 'SERVICES/ella/roleService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import ErrorSpan from 'COMPONENT/errorSpan'
export default class RoleEdit extends Component {
	constructor(props) {
		super(props);
		this.btnSubmit = this.btnSubmit.bind(this);
		this.state = {
			roleId: this.props.params.id,
			nodeVos:[],
			permissions:[],
			role:{},
			url:ellaUrl
		};
	}
	componentDidMount() {
		var roleId = this.state.roleId;
		const userId = getUserId();
		roleService.roleToUpdate(roleId,userId).then(data=>{
            var nodeVos = JSON.parse(data.data.nodeVos);
            console.log(nodeVos);
            var permissions = JSON.parse(data.data.permissions);
            var role = data.data.role;
            this.setState({
                nodeVos : nodeVos,
                permissions : permissions,
                role : role,
            })
            $("#roleName").val(role.roleName);
            $("#roleNumber").val(role.roleNumber);
            $("#remark").val(role.remark);
            var setting = {
                check: {
                    enable: true,

                },
                showLine: true,
                callback: {
                    onCheck: this.onChange.bind(this),
                }
            };
            $.fn.zTree.init($("#pageTree"), setting, nodeVos);
            var zTree = $.fn.zTree.getZTreeObj("pageTree");
            //查找需要选中的节点
            var nodes = zTree.getNodesByFilter(function(node){
                for(var i in permissions){
                    var o = permissions[i];
                    if(o != null && o != "" && o['id'] == node.id && o['level'] == node.level){
                        return true;
                    }
                }
            });
            //设置节点为选中状态
            for(var i in nodes){
                zTree.checkNode(nodes[i], true, true, true);
            }
            //展开所有节点
            zTree.expandAll(true);
		});
	}
    onChange(event, treeId, treeNode){
        successShow('pageTree');
    }
	btnSubmit(event){
        errToSuc();
		var roleId = this.state.roleId;
        event.preventDefault();
        var roleName = $("#roleName").val();
        var roleNumber = $("#roleNumber").val();
        var remark = $("#remark").val();
        var zTree = $.fn.zTree.getZTreeObj("pageTree");
        var Nodes = zTree.getCheckedNodes(true);
        var filterNodes = Nodes.filter(function(el,index){
            return el.children == null;
        });
        var permissions = filterNodes.map(function(data){
            return data.id+"_"+data.level;
        });
        var arr = {
            id:roleId,
            roleName:roleName,
            roleNumber:roleNumber,
            remark:remark,
            permissions:String(permissions),
            userId:sessionStorage.userId,
        };
        var errorMessage = '';
        if(roleName == ''){
            errorShow('roleName');
        }
        if(roleNumber == ''){
            errorShow('roleNumber');
        }
        if(permissions ==''){
            errorShow('pageTree');
        }
        if($("[name='error']").length == 0){
            $("#btnSubmit").attr("disabled","true");

            const data = JSON.stringify(arr);
            roleService.roleDoAddOrUpdate({data}).then(body=>{
                resultTip(body,'/ella/role/roleIndex');
            });
		}

	}
	render() {
		return (
			<div >
				<ContentHeader nameLg={'roleManagement'} nameSm="editRole" />
				<section className="content" >
					<div className="box box-primary color-palette-box">
						<BoxHeader name={language()['editRole']}/>
						<div className="box-body">
							<Tip ids=""/>
							<form className="form-horizontal">
								<FormInput id="roleName" name="roleName"/>
								<FormInput id="roleNumber" name="roleNo"/>
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['remark']}</label>
									<div className="col-xs-3">
										<textarea className="form-control" rows="3" id="remark"></textarea>
									</div>
								</div>
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['AuthorityAssignment']}</label>
									<div id="leftTree" className="col-xs-3 ">
										<ul id="pageTree" className="ztree" style={{width:'100%'}}>

										</ul>
									</div>
                                    <ErrorSpan id="pageTree"/>
								</div>
								<div className="row form-group">
									<div className="col-xs-2"></div>
									<div className="col-xs-1 text-center">
										<Link  to = "/ella/role/roleIndex" className="btn btn-default btn-md">
                                            {language()['return']}
										</Link>
									</div>
									<div className="col-xs-1 text-center">
										<button className="btn btn-success" id="btnSubmit" onClick={this.btnSubmit.bind(this)}>{language()['submit']}</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</section>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/role/roleEdit.js